<script setup>
import {onMounted} from "vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import EmailForm from "@/components/EmailForm.vue";
import {useHead} from "@vueuse/head";


onMounted(async () => {
  const scripts = [
      '/assets/js/vendor/modernizr-2.8.3.min.js',
    '/assets/js/vendor/jquery-3.5.1.min.js',
    '/assets/js/bootstrap.min.js',
    '/assets/js/isotope.pkgd.min.js',
    '/assets/js/owl.carousel.min.js',
    '/assets/js/jquery.nivo.slider.pack.js',
    '/assets/js/slick.min.js',
    '/assets/js/imagesloaded.pkgd.min.js',
    '/venobox/venobox.min.js',
    '/assets/js/jquery.appear.js',
    '/assets/js/jquery.knob.js',
    '/assets/js/BeerSlider.js',
    '/assets/js/theme-pluginjs.js',
    '/assets/js/jquery.meanmenu.js',
    '/assets/js/ajax-mail.js',
    '/assets/js/theme.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  await loadScriptsSequentially(scripts);
})

useHead({
  title: 'TPA Housing - 100000m2 Production Plant, 20 Years Experienced Engineer, 30 Countries House Projects',
  meta: [
    {
      name: 'description',
      content: 'content="We can provide prefabricated design expertise, construction knowledge you need to build the house you want in short time and within your budget,Steel Structure House Building,Warehouse Steel Structure,Lightweight Steel Structure and other products and services'
    }
  ]
})
</script>

<template>
  <Header/>

  <!-- breadcumb-area -->
  <div class="breadcumb-area">
    <div class="container">
      <div class="row">
        <div class="col-md-12 txtc  text-center ccase">
          <div class="brpt">
            <h2>About</h2>
          </div>
          <div class="breadcumb-inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><i class="fas fa-angle-right"></i></li>
              <li>About</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- kurigram_about_area -->
  <div class="kurigram_about_area">
    <div class="container">
      <div class="row about_area">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="carousel_imagess_area">
            <div class="imagess_id1">
              <div class="col-lg-12 carousel_pdding0">
                <div class="slide_items false ">
                  <img src="/assets/images/tpahousing-2.webp" alt="">
                </div>
              </div>
              <div class="col-lg-12 carousel_pdding0">
                <div class="slide_items false ">
                  <img src="/assets/images/tpahousing-1.webp" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 about_service">
          <div class="witr_section_right">
            <div class="witr_section_title">
              <div class="witr_section_title_inner text-left">
                <h3>Why We Are Different?</h3>
              </div>
            </div>
            <!-- em_service2_01 -->
            <div class="em-service2 sleft all_color_service">
              <div class="em_service_content ">
                <div class="em_single_service_text width_height_link_0 ">
                  <div class="service_top_image"></div>
                  <div class="text_box witr_s_flex">
                    <div class="service_top_text all_icon_color">
                      <div class="em-service-icon">
                        <i class="aprova aprova-roof"></i>
                      </div>
                    </div>
                    <div class="em-service-inner">
                      <div class="em-service-title">
                        <h3>Our Company History </h3>
                      </div>
                      <div class="em-service-desc">
                        <p>Established in 2008, Foshan TianPuAn building materials technology (TPA Housing) has evolved
                          into a full-service provider of steel structure solutions, covering consultation, custom
                          design, manufacturing, on-site installation or installation guidance, and project
                          management.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- em_service2_02 -->
            <div class="em-service2 sleft all_color_service">
              <div class="em_service_content ">
                <div class="em_single_service_text width_height_link_0 ">
                  <div class="service_top_image"></div>
                  <div class="text_box witr_s_flex">
                    <div class="service_top_text all_icon_color">
                      <div class="em-service-icon">
                        <i class="aprova aprova-analytics"></i>
                      </div>
                    </div>
                    <div class="em-service-inner">
                      <div class="em-service-title">
                        <h3>Our Success Mission</h3>
                      </div>
                      <div class="em-service-desc">
                        <p> We specialize in steel structure fabrication, steel structure workshops, and prefabricated
                          steel buildings, offering a complete product range to meet your project needs.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="witr_single_progress all_color_bar">
              <div class="witr_title2">
                <span class="witr_label">Support </span>
              </div>
              <div class="progress witr_progress-style2">
                <div class="progress-bar wow fadeInLeft" data-wow-duration="1.5s" data-wow-delay="0.2s"
                     style="width: 95%;">
                  <span class="witr_percent">95%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- kurigram_serivce2_area -->
  <div class="kurigram_serivce2_area ">
    <div class="container">
      <div class="witr_cfeature11 feature_active">
        <div class="witr_islidess_slick witr_cfeature11_idps">
          <!-- kurigram_serivce2_01 -->
          <div class="col-lg-12">
            <div class="wcr_feature_11 ">
              <div class="feature_positions_thumb">
                <img src="/assets/images/about_1.jpg" alt="">
                <div class="feature_video_post">
                  <a class="video-popup video-vemo-icon venobox vbox-item" data-vbtype="youtube" data-autoplay="true"
                     href="#" tabindex="-1">
                    <span class="fas fa-play"></span></a>
                </div>
                <div class=" feature_topicon_post all_topicon_color">
                  <i class="flaticon flaticon-team"></i>
                </div>
              </div>
              <div class="witr_sub_item_area">
                <div class="witr_sub_item  all_feature_color text-left">
                  <div class="feature_big_icon"></div>
                  <h3><a href="/projects">Production Facilities</a></h3>
                  <h2>Our Awesome </h2>
                  <p>30,000 m² manufacturing area </p>
                </div>
                <div class="car_feature_btn_icon">
                  <a href="#"><i class="fas fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_serivce2_02 -->
          <div class="col-lg-12">
            <div class="wcr_feature_11 ">
              <div class="feature_positions_thumb">
                <img src="/assets/images/about_2.jpg" alt="">
                <div class="feature_video_post">
                  <a class="video-popup video-vemo-icon venobox vbox-item" data-vbtype="youtube" data-autoplay="true"
                     href="#" tabindex="-1">
                    <span class="fas fa-play"></span></a>
                </div>
                <div class=" feature_topicon_post all_topicon_color">
                  <i class="flaticon flaticon-team"></i>
                </div>
              </div>
              <div class="witr_sub_item_area">
                <div class="witr_sub_item  all_feature_color text-left">
                  <div class="feature_big_icon"></div>
                  <h3><a href="/projects">Annual Capacity</a></h3>
                  <h2>We are best </h2>
                  <p>Over 20,000 tons of steel structures and 100,000 m² of panel materials </p>
                </div>
                <div class="car_feature_btn_icon">
                  <a href="#"><i class="fas fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_serivce2_03 -->
          <div class="col-lg-12">
            <div class="wcr_feature_11 ">
              <div class="feature_positions_thumb">
                <img src="/assets/images/about_3.jpg" alt="">
                <div class="feature_video_post">
                  <a class="video-popup video-vemo-icon venobox vbox-item" data-vbtype="youtube" data-autoplay="true"
                     href="#" tabindex="-1">
                    <span class="fas fa-play"></span></a>
                </div>
                <div class=" feature_topicon_post all_topicon_color">
                  <i class="flaticon flaticon-team"></i>
                </div>
              </div>
              <div class="witr_sub_item_area">
                <div class="witr_sub_item  all_feature_color text-left">
                  <div class="feature_big_icon"></div>
                  <h3><a href="/projects">Project Experience</a></h3>
                  <h2>Same Of </h2>
                  <p>More than 2,000 completed steel structure projects </p>
                </div>
                <div class="car_feature_btn_icon">
                  <a href="#"><i class="fas fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_serivce2_04 -->
          <div class="col-lg-12">
            <div class="wcr_feature_11 ">
              <div class="feature_positions_thumb">
                <img src="/assets/images/about_4.jpg" alt="">
                <div class="feature_video_post">
                  <a class="video-popup video-vemo-icon venobox vbox-item" data-vbtype="youtube" data-autoplay="true"
                     href="/projects" tabindex="-1">
                    <span class="fas fa-play"></span></a>
                </div>
                <div class=" feature_topicon_post all_topicon_color">
                  <i class="flaticon flaticon-team"></i>
                </div>
              </div>
              <div class="witr_sub_item_area">
                <div class="witr_sub_item  all_feature_color text-left">
                  <div class="feature_big_icon"></div>
                  <h3><a href="#">Industry Expertise</a></h3>
                  <h2>Our Awesome </h2>
                  <p>17 years of professional experience in steel construction </p>
                </div>
                <div class="car_feature_btn_icon">
                  <a href="#"><i class="fas fa-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- kurigram_counter_bg_area -->
  <div class="kurigram_counter_bg_area counter_page">
    <div class="container">
      <div class="row counter3">
        <!-- kurigram_counter_01 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="witr_counter_single all_counter_color white">
            <div class="witr_counter_icon">
              <i class="flaticon flaticon-man-1"></i>
            </div>
            <div class="witr_counter_number_inn">
              <h3 class="counter">2010</h3>
              <span>+</span>
              <h4>Founded </h4>
            </div>
          </div>
        </div>
        <!-- kurigram_counter_02 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="witr_counter_single all_counter_color white">
            <div class="witr_counter_icon">
              <i class="flaticon flaticon-team"></i>
            </div>
            <div class="witr_counter_number_inn">
              <h3 class="counter">58</h3>
              <span>+</span>
              <h4>Team</h4>
            </div>
          </div>
        </div>
        <!-- kurigram_counter_03 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="witr_counter_single all_counter_color white">
            <div class="witr_counter_icon">
              <i class="flaticon flaticon-computer"></i>
            </div>
            <div class="witr_counter_number_inn">
              <h3 class="counter">60</h3>
              <span>+</span>
              <h4>Export</h4>
            </div>
          </div>
        </div>
        <!-- kurigram_counter_04 -->
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="witr_counter_single all_counter_color white">
            <div class="witr_counter_icon">
              <i class="flaticon flaticon-select"></i>
            </div>
            <div class="witr_counter_number_inn">
              <h3 class="counter">4</h3>
              <span>+</span>
              <h4>Certificates</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- single_faq_bg_area -->
  <div class="single_faq_bg_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="witr_section_title">
            <div class="witr_section_title_inner text-center">
              <h3> Frequently Asked Questions</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row faq_top">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="single_image_area">
            <div class="single_image  ">
              <img src="/assets/images/ab3.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="accordion_area faq_style2">
            <div class="faq-part">
              <div id="accordion">
                <div class="card card-2 active show">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style collapsed" data-toggle="collapse"
                       data-target="#collapse_05" aria-expanded="false">
                      What is the maximum depth that your steel building can span?</a>
                  </div>
                  <div id="collapse_05" class=" collapse  active show" data-parent="#accordion" style="">
                    <p>Our buildings are engineered to span from 9 meters up to 40 meters clear span and further if
                      needed.</p>
                  </div>
                </div>
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_01"
                       aria-expanded="true">
                      How to protect steel structure frame from rusting?</a>
                  </div>
                  <div id="collapse_01" class="collapse   " data-parent="#accordion">
                    <p>There are two methods:2 layers(30microns+30microns)auti-rust coating and hot-dip galvanized.If
                      the house is near the coast wesuggest using galvanized solution,cause it can last longer.</p>
                  </div>
                </div>
                <!-- card -->
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_02"
                       aria-expanded="true">
                      Is it easy to install a steel building?</a>
                  </div>
                  <div id="collapse_02" class="collapse   " data-parent="#accordion">
                    <p>It is not so difficult to install this kind of steel house building, we will guide you with an
                      installation instruction drawing, the construction is a simple bolt-together process, and you just
                      need a crane of about 20ton to help with the installation work.</p>
                  </div>
                </div>
                <!-- card -->
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_03"
                       aria-expanded="true">
                      Why does wind speed affect prices that much?</a>
                  </div>
                  <div id="collapse_03" class="collapse   " data-parent="#accordion">
                    <p>For most of the steel structure buildings, we design wind speed is about 110km/h. But for some
                      strong wind countries,110km/h is not enough, like the Philippines and Mauritius 150~280km/h
                      windspeed need to enlarge the beam and column, that will use more steel on it then increase the
                      price a lot.</p>
                  </div>
                </div>
                <!-- card -->
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_04"
                       aria-expanded="true">
                      What accessories do you provide for customizing steel buildings?</a>
                  </div>
                  <div id="collapse_04" class="collapse   " data-parent="#accordion">
                    <p>Along with the wall and roof insulation systems, we also offer skylights, commercial-grade
                      ventilation devices such as roof turbine vents and wall louver vents, rolling doors, and double
                      sliding doors.</p>
                  </div>
                </div>
                <!-- card -->
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_05"
                       aria-expanded="true">
                      Is it beter to add a brick wall to my metal building?</a>
                  </div>
                  <div id="collapse_05" class="collapse   " data-parent="#accordion">
                    <p>Yes,it is.The brick wall can be moisture resistance and also fire resistance. 1~3m high brick
                      wall combine the metal sheet or sandwich panel will be durable and look nice.</p>
                  </div>
                </div>
                <!-- card -->
                <div class="card card-2">
                  <div class="card-header witr_ac_card">
                    <a href="#" class="card-link witr_ac_style" data-toggle="collapse" data-target="#collapse_06"
                       aria-expanded="true">
                      What kind of steel sections you can produce?</a>
                  </div>
                  <div id="collapse_06" class="collapse   " data-parent="#accordion">
                    <p>For the steel building mostly we make Q235B and Q355B H beam. That includes standard section and
                      customized section(also call Tapered section). The customized section may use less steel, because
                      it is just one end bigger, not like the standard section with two ends same size. But will need
                      production time and need more labor cost. </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="kurigram_video_bg_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="video-part">
            <div class="video-overlay witr_all_color_v">
              <div class="video-item text-center">
                <a class="video-popup video-vemo-icon venobox vbox-item" data-vbtype="youtube" data-autoplay="true"
                   href="#">
                  <i class="fas fa-play"></i></a>
                <h3>Get Introduction </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!--  &lt;!&ndash; kurigram_team_area &ndash;&gt;-->
<!--  <div class="kurigram_team_area team_style4">-->
<!--    <div class="container">-->
<!--      <div class="row">-->
<!--        <div class="col-lg-12">-->
<!--          <div class="witr_section_title">-->
<!--            <div class="witr_section_title_inner text-center">-->
<!--              <h3>Our Team</h3>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="row team_top">-->
<!--        &lt;!&ndash; kurigram_team_01 &ndash;&gt;-->
<!--        <div class="col-lg-6 col-md-6 col-sm-12">-->
<!--          <div class="em-team all_color_team ">-->
<!--            <div class="em-team-one">-->
<!--              <div class="em-team-content-image-inner">-->
<!--                <div class="em-team-content-image">-->
<!--                  <img src="/assets/images/business1.png" alt=""/>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="em-team-content-waraper all_content_bg_color">-->
<!--                <div class="em-team-content-title-inner">-->
<!--                  <div class="em-content-title">-->
<!--                    <h5><a href="#">Ray Chan</a></h5>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-subtitle-inner">-->
<!--                  <div class="em-content-subtitle">-->
<!--                    <span>Sales Manager</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-socials-inner">-->
<!--                  <div class="em-team-content-socials all_team_s_color">-->
<!--                    <a href="https://www.facebook.com/profile.php?id=100083074701518"><i-->
<!--                        class="icofont-facebook"></i></a>-->
<!--                    <a href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw"><i-->
<!--                        class="icofont-youtube"></i></a>-->
<!--                    <a href="https://api.whatsapp.com/send?phone=8613929160928"><i class="icofont-whatsapp"></i></a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; kurigram_team_02 &ndash;&gt;-->
<!--        <div class="col-lg-6 col-md-6 col-sm-12">-->
<!--          <div class="em-team all_color_team ">-->
<!--            <div class="em-team-one">-->
<!--              <div class="em-team-content-image-inner">-->
<!--                <div class="em-team-content-image">-->
<!--                  <img src="/assets/images/business2.png" alt=""/>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="em-team-content-waraper all_content_bg_color">-->
<!--                <div class="em-team-content-title-inner">-->
<!--                  <div class="em-content-title">-->
<!--                    <h5><a href="#">Kary Huang</a></h5>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-subtitle-inner">-->
<!--                  <div class="em-content-subtitle">-->
<!--                    <span>Sales Supervisor</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-socials-inner">-->
<!--                  <div class="em-team-content-socials all_team_s_color">-->
<!--                    <a href="https://www.facebook.com/profile.php?id=100083074701518"><i-->
<!--                        class="icofont-facebook"></i></a>-->
<!--                    <a href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw"><i-->
<!--                        class="icofont-youtube"></i></a>-->
<!--                    <a href="https://api.whatsapp.com/send?phone=8613929163028"><i class="icofont-whatsapp"></i></a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; kurigram_team_03 &ndash;&gt;-->

<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

<!--  &lt;!&ndash; kurigram_contact_area &ndash;&gt;-->
  <EmailForm/>


  <!-- kurigram_blog_bg_area -->
  <div class="kurigram_blog_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="witr_section_title">
            <div class="witr_section_title_inner text-center">
              <h3>Blogs</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="witr_blog_area11 blog_top">
        <div class="blog_wrap blog11_idblog1">
          <!-- kurigram_blog_bg_01 -->
          <div class="witr_all_mb_30 col-lg-12">
            <div class="busi_singleBlog">
              <div class="witr_sb_thumb">
                <a href="/blogs/2335-m2-steel-structure-office-and-warehouse(Israel)"> <img src="/assets/images/ad35051081-2335_m2_steel_structure_office_and_warehouse_israel.jpg" alt=""></a>
                <div class="witr_top_category">
                  <ul class="post-categories">
                    <li><a href="/blogs" rel="category tag">Blogs</a></li>
                  </ul>
                </div>
              </div>
              <div class="all_blog_color">
                <div class="witr_blog_con bs5">
                  <h2><a href="/blogs/2335-m2-steel-structure-office-and-warehouse(Israel)">2335 m2 steel structure office and warehouse(Israel)</a></h2>
                </div>
                <div class="em-blog-content-area_adn ">
                  <div class="learn_more_adn">
                    <a class="learn_btn adnbtn2" href="/blogs">Read More </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_blog_bg_02 -->
          <div class="witr_all_mb_30 col-lg-12">
            <div class="busi_singleBlog">
              <div class="witr_sb_thumb">
                <a href="/blogs/Steel-structure-metal-building-homes-in-Netherlands"> <img src="/assets/images/ad33908090-steel_structure_metal_building_homes_in_netherlands.jpg" alt=""></a>
                <div class="witr_top_category">
                  <ul class="post-categories">
                    <li><a href="/blogs" rel="category tag">Blogs</a></li>
                  </ul>
                </div>
              </div>
              <div class="all_blog_color">
                <div class="witr_blog_con bs5">
                  <h2><a href="/blogs/Steel-structure-metal-building-homes-in-Netherlands">Steel structure metal building homes in Netherlands</a></h2>
                </div>
                <div class="em-blog-content-area_adn ">
                  <div class="learn_more_adn">
                    <a class="learn_btn adnbtn2" href="/blogs">Read More </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_blog_bg_03 -->
          <div class="witr_all_mb_30 col-lg-12">
            <div class="busi_singleBlog">
              <div class="witr_sb_thumb">
                <a href="/blogs/126-sqm-STEEL-STRUCTURE-SEAFOOD-STORAGE-(Vancouver,-CA)"> <img src="/assets/images/ad35186593-126_sqm_steel_structure_seafood_storage_vancouver_ca.jpg" alt=""></a>
                <div class="witr_top_category">
                  <ul class="post-categories">
                    <li><a href="/blogs" rel="category tag">Blogs</a></li>
                  </ul>
                </div>
              </div>
              <div class="all_blog_color">
                <div class="witr_blog_con bs5">
                  <h2><a href="/blogs/126-sqm-STEEL-STRUCTURE-SEAFOOD-STORAGE-(Vancouver,-CA)">126 sqm STEEL STRUCTURE SEAFOOD STORAGE (Vancouver, CA)</a></h2>
                </div>
                <div class="em-blog-content-area_adn ">
                  <div class="learn_more_adn">
                    <a class="learn_btn adnbtn2" href="/blogs">Read More </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- kurigram_blog_bg_04 -->
          <div class="witr_all_mb_30 col-lg-12">
            <div class="busi_singleBlog">
              <div class="witr_sb_thumb">
                <a href="/blogs/Metal-steel-structure-frame-gas-station(Tanzania)"> <img src="/assets/images/ad35104414-metal_steel_structure_frame_gas_station_tanzania.jpg" alt=""></a>
                <div class="witr_top_category">
                  <ul class="post-categories">
                    <li><a href="/blogs" rel="category tag">Blogs</a></li>
                  </ul>
                </div>
              </div>
              <div class="all_blog_color">
                <div class="witr_blog_con bs5">
                  <h2><a href="/blogs/Metal-steel-structure-frame-gas-station(Tanzania)">Metal steel structure frame gas station(Tanzania)</a></h2>
                </div>
                <div class="em-blog-content-area_adn ">
                  <div class="learn_more_adn">
                    <a class="learn_btn adnbtn2" href="/blogs">Read More </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Footer/>
</template>

<style scoped lang="scss">

</style>